import { createFileRoute } from '@tanstack/react-router'
import { Diario } from '@/features/portal/diario'
import { PortalShell } from '@/features/portal/shell'

/** Diário entre sessões. O que é escrito aqui sai selado deste navegador. */
export const Route = createFileRoute('/_portal/portal_/diario')({
  component: function DiarioDoPortal() {
    return (
      <PortalShell title="Diário">
        <Diario />
      </PortalShell>
    )
  },
})
